<div class="tile" [class.outdated]="isOutdated">
  @if (elemDef) {
    <div
      [attr.data-color]="displayColor"
      class="icon-container" (click)="togglePopover(); $event.stopPropagation()">
      <div
        [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
        class="icon"
      ></div>
    </div>
  }
  <span class="tile-text">
    <span class="tile-info">
      <span class="name">{{displayName}}</span>
      <span class="facets" [class.empty]="!facetValues.length">
        @for (val of facetValues; track $index) {
          @if (!$first) {<i class="fa-solid fa-circle-dot"></i>}
          <span>{{ val }}</span>
        }
      </span>
      <span class="value-row">
        <span class="value">{{displayValue}} {{displayUnits}}</span>
        @if (displayStaleValue) {
          <span class="stale-value" @fadeInOut>{{displayStaleValue}}</span>
        }
      </span>
    </span>
  </span>
</div>
